import { floor } from 'lodash-es';
import { IPromessa } from '@/models/IPromessa';

const currencyFormatter = new Intl.NumberFormat(
  'pt-BR',
  {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
);

function currency(value: number, showSymbol = true): string {
  const formatted = currencyFormatter.format(value);
  return showSymbol ? `R$ ${formatted}` : formatted;
}

function percentual(value: number, precisao = 0): string {
  return `${floor(value, precisao).toFixed(precisao)}%`.replace('.', ',');
}

function formatDate(date: Date | string): string {
  const normalized = date instanceof Date ? date : new Date(date);
  return normalized.toLocaleDateString('pt-BR');
}

function getMonthName(date: Date | string): string {
  const normalized = date instanceof Date ? date : new Date(date);
  const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  return months[normalized.getMonth()];
}

function resumoProposta(proposta?: IPromessa | null): string {
  if (!proposta) return '';

  let texto = '';

  if (proposta.valorEntrada) {
    if (!proposta.quantidadeParcelas) texto += '1 x ';
    texto += `${currency(proposta.valorEntrada)}`;
  }

  if (proposta.quantidadeParcelas && proposta.valorParcela) {
    if (proposta.valorEntrada) texto += ' +';
    texto += ` ${proposta.quantidadeParcelas} x ${currency(proposta.valorParcela)}`;
  }

  texto += ` = ${currency(proposta.valorTotalCalculado)}`;

  return texto;
}

export {
  currency,
  percentual,
  formatDate,
  resumoProposta,
  getMonthName,
};
